// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    PrescriptionV2AccountPrescriptionGetByAccountIdResponse,
    PrescriptionV2NdcGetByIdResponse,
    PrescriptionV2ProgramNdcGetByProgramIdResponse,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgePrescriptionApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param accountId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountPrescriptionGetByAccountId (accountId: number, xProgramId?: string): Promise<AxiosResponse<PrescriptionV2AccountPrescriptionGetByAccountIdResponse>> {
        const _url_ = '/edge/prescription/v2/AccountPrescription/GetByAccountId/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountPrescriptionGetByAccountId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PrescriptionV2AccountPrescriptionGetByAccountIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriptionV2AccountPrescriptionGetByAccountIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param code 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async ndcGetByCode (code: string, xProgramId?: string): Promise<AxiosResponse<PrescriptionV2NdcGetByIdResponse>> {
        const _url_ = '/edge/prescription/v2/Ndc/GetByCode/{code}'
            .replace('{' + 'code' + '}', encodeURIComponent(String(code)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'code' is not null or undefined
        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling ndcGetByCode.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PrescriptionV2NdcGetByIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriptionV2NdcGetByIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param id 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async ndcGetById (id: number, xProgramId?: string): Promise<AxiosResponse<PrescriptionV2NdcGetByIdResponse>> {
        const _url_ = '/edge/prescription/v2/Ndc/GetById/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling ndcGetById.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PrescriptionV2NdcGetByIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriptionV2NdcGetByIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param programId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async programNdcGetByProgramId (programId: number, xProgramId?: string): Promise<AxiosResponse<PrescriptionV2ProgramNdcGetByProgramIdResponse>> {
        const _url_ = '/edge/prescription/v2/ProgramNdc/GetByProgramId/{programId}'
            .replace('{' + 'programId' + '}', encodeURIComponent(String(programId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'programId' is not null or undefined
        if (programId === null || programId === undefined) {
            throw new Error('Required parameter programId was null or undefined when calling programNdcGetByProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PrescriptionV2ProgramNdcGetByProgramIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriptionV2ProgramNdcGetByProgramIdResponse");
        }
        return response;
    }
}
